import { render, staticRenderFns } from "./childcustomer.vue?vue&type=template&id=049ae167&"
import script from "./childcustomer.vue?vue&type=script&lang=js&"
export * from "./childcustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports